import { userConstants } from '../user.constants';

const initialState = {
  items: [],
  organisationById: {},
  accountsByOrgId: {}
};

export const organisations = (state = initialState, action) => {
  switch (action.type) {
    case userConstants.GET_ORGANISATIONS_SUCCESS:
      return {
        ...state,
        items: (action.result && action.result.items) || []
      };
    case userConstants.GET_ORGANISATION_SUCCESS:
      return {
        ...state,
        organisationById: {
          ...state.organisationById,
          [action.orgId]: action.result
        }
      };
    case userConstants.GET_ORGANISATION_ACCOUNTS_SUCCESS:
      return {
        ...state,
        accountsByOrgId: {
          ...state.accountsByOrgId,
          [action.orgId]: (action.result && action.result.items) || []
        }
      };
    case userConstants.CREATE_ORGANISATION_SUCCESS:
      return {
        ...state,
        items: [...state.items, action.result]
      };
    case userConstants.UPDATE_ORGANISATION_SUCCESS:
      return {
        ...state,
        items: state.items.map(org =>
          (org.id === action.result.id ? action.result : org)),
        organisationById: {
          ...state.organisationById,
          [action.result.id]: action.result
        }
      };
    case userConstants.DELETE_ORGANISATION_SUCCESS: {
      const nextOrganisationById = { ...state.organisationById };
      const nextAccountsByOrgId = { ...state.accountsByOrgId };
      delete nextOrganisationById[action.orgId];
      delete nextAccountsByOrgId[action.orgId];
      return {
        ...state,
        items: state.items.filter(org => org.id !== action.orgId),
        organisationById: nextOrganisationById,
        accountsByOrgId: nextAccountsByOrgId
      };
    }
    case userConstants.ASSIGN_ACCOUNT_ORGANISATION_SUCCESS:
      return state;
    default:
      return state;
  }
};
